/** Store-scoped keys: switching stores never shares cache. */
export const feedKeys = {
  all: (storeId: string) => ['stores', storeId, 'feeds'] as const,
  status: (storeId: string) => [...feedKeys.all(storeId), 'status'] as const,
};
